export default {
  title: 'Ship Schedule Query',
  description: 'Query shipping schedules and matching rates',

  // Search area
  search: {
    title: 'Ship Schedule Query',
    originPort: 'Origin Port',
    destinationPort: 'Destination Port',
    originPortPlaceholder: 'Please select or enter origin port',
    destinationPortPlaceholder: 'Please select or enter destination port',
    etd: 'etd',
    etdTime: 'Please select date',
    scheduleRange: 'Schedule Range',
    selectScheduleRange: 'Please select schedule range',
    oneWeek: 'Within 1 week',
    twoWeeks: 'Within 2 weeks',
    threeWeeks: 'Within 3 weeks',
    fourWeeks: 'Within 4 weeks',
    searchButton: 'Search Schedule',
    resetButton: 'Reset'
  },

  // Query results
  results: {
    title: 'Query Results',
    statsText: 'Found {total} schedule records, {withRates} with matching rates',
    emptySearch: 'Please select origin port and destination port to search',
    emptyResult: 'No matching schedule information found, please try other ports or contact customer service',
    syncingDescription: 'A third-party query data is being invoked. It is expected to take 5 minutes. Please try again later'
  },

  // Table column titles
  columns: {
    routeInfo: 'Route Info',
    spaceSharing: 'Space Sharing',
    vessel: 'Vessel & Voyage',
    origin: 'Origin Port',
    destination: 'Destination Port',
    transit: 'Transit & Service',
    rates: 'Matching Rates'
  },

  // Space sharing information
  spaceSharing: {
    internalVoyage: 'Internal Voyage',
    spaceAgent: 'Space Agent',
    dangerousAgent: 'Dangerous Goods Agent'
  },

  // Vessel & Voyage
  vesselVoyage: {
    sailingSchedule: 'Sailing Schedule'
  },

  // Cutoff times
  cutoff: {
    title: 'Cutoff Times',
    cargo: 'Container Yard Cut-off',
    doc: 'Doc Cutoff',
    vgm: 'VGM Cutoff',
    dangerous: 'Dangerous Cutoff',
    cyOpen: 'Earliest Receiving Date',
    booking: 'Booking Cutoff',
    custom: 'Custom Cutoff'
  },

  // Port related
  port: {
    terminalCode: 'Terminal Code'
  },

  // Port time labels
  portTime: {
    eta: 'ETA',
    etd: 'ETD'
  },

  // Transit information
  transit: {
    days: 'Days',
    direct: 'Direct',
    transfer: 'Transit',
    transitPortsInfo: 'Transit Port Information',
    viaPortsText: 'Via {count} ports'
  },

  // Rate module
  rates: {
    // With rates
    withRates: {
      title: 'Matching Rates',
      foundText: 'Found {count} rate options',
      priceUnit: 'from/20GP',
      viewDetails: 'View Rate Details',
      inquireNow: 'Inquire Now'
    },
    // No rates
    noRates: {
      title: 'No Rates Available',
      description: 'No public rates available for this schedule',
      inquireNow: 'Inquire Now',
      inquiryNote: 'Dedicated sales will quote you immediately'
    }
  },

  // Service types
  serviceType: {
    direct: 'Direct',
    transit: 'Transit'
  },

  // Messages
  messages: {
    selectPorts: 'Please select origin port and destination port',
    loadDataFailed: 'Failed to load schedule data, please try again later',
    baseDataLoadFailed: 'Failed to load base data, please try again later'
  }
}
